// extracted by mini-css-extract-plugin
module.exports = {"first-item":"styles-module__first-item___23Q7S","last-item":"styles-module__last-item___GXoG3"};